import { render, staticRenderFns } from "./ReportDataModal.vue?vue&type=template&id=0d2fb963&scoped=true&"
import script from "./ReportDataModal.vue?vue&type=script&lang=js&"
export * from "./ReportDataModal.vue?vue&type=script&lang=js&"
import style0 from "./ReportDataModal.vue?vue&type=style&index=0&id=0d2fb963&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2fb963",
  null
  
)

export default component.exports